export enum EStatusOptions {
  Winter = 'Winter',
  Suspend = 'Suspend',
  CloseHide = 'Close & Hide',
  Close = 'Close',
}
